<template>
  <v-data-table 
    :headers="headers" 
    item-key="LocationID" 
    :items="items.results" 
    :loading="loading" 
    :server-items-length="items.totalResults" 
    :options.sync="options" 
    show-expand 
    :expanded.sync="expanded" 
    :footer-props="{ 'items-per-page-options': [5, 10, 15, 20, -1] }">
    <template #:body="{items}">
      <tbody v-if="items.length > 0">
        <tr v-for="item in items" :key="item.LocationID">
          <td>{{`${item.State}`}}</td>
          <td>{{`${item.LocationName}`}}</td>
          <td>{{`${item.Address}`}}</td>
          <td>{{`${item.Contact}`}}</td>
          <td>{{`${item.Phone}`}}</td>
          <td>{{`${item.Email}`}}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td :colspan="headers.length" style="text-align: center">No Locations</td>
        </tr>
      </tbody>
    </template>
    <template #[`item.Jobs`]="{item}">
      <td>
        <router-link :to="`/jobs?locationId=${item.LocationID}`">Jobs</router-link>
      </td>
    </template>
    <template #[`item.data-table-expand`]="{ item, isExpanded, expand }">
      <v-btn 
        icon 
        elevation="1" 
        @click="expand(true)" 
        v-if="item.SecondaryContact != null && item.SecondaryPhone != null && item.SecondaryEmail != null && !isExpanded">
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
      <v-btn 
        icon 
        elevation="1" 
        @click="expand(false)" 
        v-if="item.SecondaryContact != null && item.SecondaryPhone != null && item.SecondaryEmail != null && isExpanded">
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </template>
    <template #expanded-item="{ item }">
      <td colspan="8">
        <span class="expandedRowDetails">Secondary Contact: {{item.SecondaryContact == null ? "-" : item.SecondaryContact}}</span>
        <span class="expandedRowDetails">Phone: {{item.SecondaryPhone == null ? "-" : item.SecondaryPhone}}</span>
        <span class="expandedRowDetails">Email: {{item.SecondaryEmail == null ? "-" : item.SecondaryEmail}}</span>
      </td>
    </template>
  </v-data-table>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as locationAPI from '@/api/locationAPI';
import PaginatedResults from '../../../../shared/models/paginatedResults';
import * as UserAPI from '@/api/userAPI';
import User from '../../../../shared/models/user';

@Component({})
export default class LocationList extends Vue {
  @Prop(Number) public stateID!: number | null;
  @Prop(String) public location!: string | null;
  @Prop(String) public contact!: string | null;
  @Prop(String) public email!: string | null;

  @Watch('options', { immediate: true, deep: true })
  onOptionsChanged(value: any, oldValue: any) {
    if(oldValue != undefined) {
      this.load();
    }
  }

  private get headers() {
    return [
      {
        text: 'State',
        value: 'State',
        sortable: true,
      },
      {
        text: 'Name',
        value: 'LocationName',
        sortable: true,
      },
      {
        text: 'Address',
        value: 'Address',
        sortable: true,
      },
      {
        text: 'Contact',
        value: 'Contact',
        sortable: true,
      },
      {
        text: 'Phone',
        value: 'Phone',
        sortable: true,
      },
      {
        text: 'Email',
        value: 'Email',
        sortable: true,
      },
      {
        text: 'Links',
        value: 'Jobs',
        sortable: false,
      },
    ];
  }

  private loading = false;
  private loadError = "";
  private options = { sortBy:[], sortDesc:[], page: 1, itemsPerPage: 20 };
  private expanded = [];
  private loggedInUser: User | null = null;

  private items: PaginatedResults = {
    totalResults: 0,
    results: []
  };

  public async load() {
    this.loadError = "";
    this.loading = true;

    //Race condition with state ID change between parent and child components
    await this.$nextTick();

    const { sortBy, sortDesc, page, itemsPerPage } = this.options;
    this.loggedInUser = await UserAPI.getLoggedInUser();

    this.items = {
      totalResults: 0,
      results: []
    };

    try {
      this.items = await locationAPI.getLocations(page
        , itemsPerPage
        , sortBy.length === 1 ? sortBy[0] : null
        , sortDesc.length === 1 ? sortDesc[0] : null
        , this.stateID
        , this.location
        , this.contact
        , this.email);
    } catch (e) {
      this.loadError = (e as Error).message;
    } finally {
      this.loading = false;
    }
  }
}
</script>

<style>
.v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: none;
}
.expandedRowDetails {
  margin-left: 25px; 
  margin-right: 25px;
}

@media (max-width: 600px) {
.expandedRowDetails {
    margin-left: 0px; 
    margin-right: 0px;
    display: flex;
  }
}


</style>
